import { computed, ref, watch } from 'vue';
import { useLoggingStore } from 'src/stores/logging';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { axiosCallerPlugin } from 'src/plugins/axios/componentAxiosCallerPlugin';
import { ChatMiscDataPlugin } from 'src/features/messaging/chat/components/methods/misc';
/**
 * Plugin containing method to query for listing
 * to get video count and other listing count
 * for this listing
 */
const ChatListingPlugin = () => {
    const loggingStore = useLoggingStore();
    const { axiosCall } = axiosCallerPlugin();
    const { appType, isChatUser, convo, liveConvo } = ChatMiscDataPlugin();
    const listing = computed(() => {
        if (!liveConvo.value[convo.value.id])
            return {
                id: '',
                name: ''
            };
        const convoData = liveConvo.value[convo.value.id];
        return {
            id: convoData.listing_id.toString(),
            name: convo.value.listing_name
        };
    });
    const otherListingCount = ref(0);
    const videoCount = ref(0);
    const listingIsActive = ref({
        active: null,
        approved: null
    });
    const { subject: listingWatcher$ } = rxInitSubjectCallback();
    useObservable(listingWatcher$.pipe(tap(() => {
        if (isChatUser.value || (appType.value !== 'getspaces')) {
            listingIsActive.value = {
                active: true,
                approved: true
            };
        }
    }), filter(() => !isChatUser.value), filter(() => appType.value === 'getspaces'), filter(({ newValue, oldValue }) => {
        return newValue && (newValue !== oldValue);
    }), map(({ newValue }) => newValue), filter(v => v.id !== null), map(({ id }) => id), switchMap((id) => {
        return of('').pipe(switchMap(() => {
            return axiosCall({
                type: 'list',
                state: 'card',
                loading: false,
                url: 'host_manage_space_2',
                params: {
                    fields: [
                        'id',
                        'active',
                        'approved',
                        'video_count'
                    ]
                },
                alert: false
            });
        }), catchError((err) => {
            void loggingStore.errorHandler(err);
            return of({
                success: false,
                data: null
            });
        }), filter(({ success }) => success), filter(({ data }) => data !== null), map(({ data }) => data), map(({ results }) => results), tap((v) => {
            let hasOtherListingsCount = 0;
            for (let i = 0; i < v.length; i++) {
                const listing = v[i];
                if (Number(listing.id) === Number(id)) {
                    // get video count
                    videoCount.value = listing.video_count || 0;
                    listingIsActive.value = {
                        active: listing.active,
                        approved: listing.approved
                    };
                    continue;
                }
                if (!listing.approved || !listing.active) {
                    continue;
                }
                // if have other active listings
                hasOtherListingsCount += 1;
            }
            otherListingCount.value = hasOtherListingsCount;
        }));
    })));
    watch(listing, (newValue, oldValue) => {
        listingWatcher$.next({ newValue, oldValue });
    });
    return {
        listing,
        listingIsActive,
        otherListingCount,
        videoCount
    };
};
export { ChatListingPlugin };
